import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { filter } from 'rxjs';
import { TsSnackbarService } from 'tsui';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SheetTemplate } from 'app/modules/settings/sheet-templates/sheet-templates.types';
import { SheetTemplatesService } from 'app/modules/settings/sheet-templates/sheet-templates.service';
import { SheetTemplatesAddComponent } from 'app/modules/settings/sheet-templates/add-template/add-template.component';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';

@Component({
  selector: 'sheet-templates-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SheetTemplatesListComponent extends OnDestroyMixin implements OnInit, AfterViewInit {
  public sheetTemplatesCount: number;
  public sheetTemplatesTableColumns: string[] = ['name', 'created_at', 'updated_at', 'actions'];
  public dataSource: MatTableDataSource<SheetTemplate>;

  @ViewChild(MatSort) private sort: MatSort;

  constructor(
    private readonly matDialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    private readonly sheetsTemplatesService: SheetTemplatesService,
    private readonly confirmService: ConfirmService,
    private readonly snackBar: TsSnackbarService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.fetchSheetTemplates();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  private fetchSheetTemplates(): void {
    this.sheetsTemplatesService.sheetTemplates$
      .pipe(untilComponentDestroyed(this))
      .subscribe((sheetTemplates: SheetTemplate[]) => {
        this.dataSource = new MatTableDataSource<SheetTemplate>(sheetTemplates);
        this.sheetTemplatesCount = sheetTemplates.length;
      });
  }

  public deleteSheetTemplate(sheetTemplate: SheetTemplate): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((result: boolean) => result))
      .subscribe(() => {
        this.sheetsTemplatesService
          .deleteSheetTemplate(sheetTemplate.id)
          .pipe(untilComponentDestroyed(this))
          .subscribe({
            next: () => this.snackBar.open('Sheet template deleted successfully', 'success'),
            error: () => this.snackBar.open('Sheet template deletion failed', 'error'),
            complete: () => this.cdRef.detectChanges(),
          });
      });
  }

  public openAddTemplateDialog(): void {
    this.matDialog
      .open(SheetTemplatesAddComponent, {
        panelClass: 'mailbox-compose-dialog',
      })
      .afterClosed()
      .pipe(untilComponentDestroyed(this))
      .subscribe({
        next: () => this.snackBar.open('Sheet template succesfully successfully', 'success'),
        error: () => this.snackBar.open('Sheet template creation failed', 'error'),
        complete: () => this.cdRef.detectChanges(),
      });
  }

  public trackByFn(index: number, item: SheetTemplate): number {
    return item.id || index;
  }
}
